/*
    Upselling in Cart
*/

document.addEventListener('DOMContentLoaded', () => {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(res => res.json())
    .then(cart => handleCartLoad(cart))
    .catch(err => console.error(err));
});

// handles the "Geschenkoptionen"-section visibility when delete an item from cart
document.addEventListener('onItemDeleted', () => {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(res => res.json())
    .then(cart => handleCartLoad(cart))
    .catch(err => console.error(err));
});

// handles the "Geschenkoptionen"-section visibility when item quantity changed in cart
document.addEventListener('onQuantityChange', () => {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(res => res.json())
    .then(cart => handleCartLoad(cart))
    .catch(err => console.error(err));
});
const handleCartLoad = function (cart) {
    const packagingOptions = getPackagingOptionsFromSetting();
    const packagingOptionsProductsLimit = getPackagingOptionsProductsLimitFromSetting();
    const packagingSelector = document.querySelector("packaging-options-selector");

    const upsellingSection = document.querySelector('.upselling[data-section-upselling]')

    const singleProductCollectionPackagingOptions = packagingOptions.filter(el => el.collectionHandle == "geschenkoption-einzelversand");
    const multiProductCollectionPackagingOptions = packagingOptions.filter(el => el.collectionHandle == "geschenkoption-massenversand");
    
    const upsellingProductsLimit = getUpsellingProductsLimitFromSetting();
    const upsellingEnabled = isUpsellingEnabled();

    const cartItemsCount = cart.items.filter(el => !(el.properties._is_related_cover == "true") && !el.product_type.includes("PPLR_HIDDEN_PRODUCT") && !packagingOptions.find(elem => el.id === elem.variantId)).reduce((a, b) => a + b.quantity, 0);
    const cartCheckoutButton = document.querySelector(".cart__checkout-button");

    if (cart.items.length) {
        cartCheckoutButton.removeAttribute("disabled");
    }

    // Check if all cart items related cover is exist
    validateLineItemsRelatedCover(cart.items);

    // Show upselling products
    if (upsellingEnabled) {
        if (upsellingProductsLimit) {
            if (cartItemsCount <= upsellingProductsLimit) {
                upsellingSection?.classList.remove('hidden');
            } else {
                upsellingSection?.classList.add('hidden');
            }   
        } else {
            upsellingSection?.classList.remove('hidden');
        }   
    }

    // Show Packaging Options if cart items count is less or equal to the "Packaging Options" limit
    if (cartItemsCount && cartItemsCount <= packagingOptionsProductsLimit) {
        if (packagingSelector) {
            packagingSelector.removeAttribute("hidden");
        }
    }

    // Validate cart items
    const cartHasPackagingItem = !!cart.items.filter(el => packagingOptions.some(elem => el.id === elem.variantId)).length;
    const cartSingleCollectionItems = cart.items.filter(el => singleProductCollectionPackagingOptions.some(elem => el.id === elem.variantId));
    const cartMultiCollectionItems = cart.items.filter(el => multiProductCollectionPackagingOptions.some(elem => el.id === elem.variantId));

    if (cartHasPackagingItem) {
        if (cartItemsCount == 1) {     
            if (cartSingleCollectionItems.length) {
                // Disable Input Fields for Packaging Options
                Array.from(cartSingleCollectionItems).forEach(el => {
                    let input = document.querySelector(`.quantity__input[data-variant-id="${el.id}"]`);
                    if (input) {
                            const plus_button = input.parentElement.querySelector(("button[name='plus']"));
                            const minus_button = input.parentElement.querySelector(("button[name='minus']"));

                            plus_button.disabled = true;
                            plus_button.classList.add("disabled");

                            minus_button.disabled = true;
                            minus_button.classList.add("disabled");

                            input.disabled = true;
                    }
                });
            }
            // Remove packaging items which related to multi-products collection if cart has only one item
            if (cartMultiCollectionItems.length) {
                handleInvalidCart(); 
            }
        }
        // Remove packaging items which related to single-products collection if cart has more than one item
        if (cartItemsCount > 1) {
            if (cartSingleCollectionItems.length) {
                handleInvalidCart(); 
            }
        }
        // Remove packaging items if cart is empty
        if (!cartItemsCount) {
            handleInvalidCart();
        }
    }

    // Validate upselling products && check cart items count is less than the limit
    if ((cartHasPackagingItem && upsellingEnabled && (cartItemsCount > upsellingProductsLimit))) {
        handleInvalidCart();
    }
};

const handleInvalidCart = function () {
    const data = { updates: {} };    
    const packagingOptionsIds = getPackagingOptionsFromSetting().map(el => el.variantId);
    packagingOptionsIds.forEach(id => id ? data.updates[id] = 0 : false);
    updateCart(data);
}


const updateCart = function (data) {
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(
        cart => {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
    )
    .catch(err => console.error(err))
}

const addToCart = function (variantId, quantity, properties = null) {
    const payload = {
        id: variantId,
        quantity: quantity
    };

    if (properties) {
        payload['properties'] = properties;
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(
        cart => {
            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
    )
    .catch(err => console.error(err))
}

const validateLineItemsRelatedCover = (line_items) => {
    line_items.forEach(item => {
        let relatedCover = Number(item.properties?._related_cover);
        if (relatedCover) {
            let isRelatedCoverAdded = line_items.find(el => el.id == relatedCover);
            if(!isRelatedCoverAdded) {
                addToCart(relatedCover, item.quantity, {_is_related_cover: "true"});
            }
        }
    })
}

function getPackagingIdsFromSetting() {
    const $upsellingSettings = document.querySelector('[data-upselling-settings]');
    try { data = JSON.parse($upsellingSettings ? $upsellingSettings.textContent : "{}"); } catch (error) { data = {}; };
    const packagingSettingItemIds = data?.products?.map(product => product.variantId) || [];
    return packagingSettingItemIds;
}

function getUpsellingProductsLimitFromSetting() {
    const $upsellingSettings = document.querySelector('[data-upselling-settings]');
    try { data = JSON.parse($upsellingSettings ? $upsellingSettings.textContent : "{}"); } catch (error) { data = {}; };
    const upsellingLimit = data?.general?.upselling_limit;
    return upsellingLimit;
}

function getPackagingOptionsProductsLimitFromSetting() {
    const $upsellingSettings = document.querySelector('[data-upselling-settings]');
    try { data = JSON.parse($upsellingSettings ? $upsellingSettings.textContent : "{}"); } catch (error) { data = {}; };
    const packaging_options_products_limit = data?.general?.packaging_options_products_limit;
    return packaging_options_products_limit;
}

function isUpsellingEnabled() {
    const $upsellingSettings = document.querySelector('[data-upselling-settings]');
    try { data = JSON.parse($upsellingSettings ? $upsellingSettings.textContent : "{}"); } catch (error) { data = {}; };
    const upselling_enabled = data?.general?.upselling_enabled || false;
    return upselling_enabled;
}


function getPackagingOptionsFromSetting() {
    const $upsellingSettings = document.querySelector('[data-upselling-settings]');
    try { data = JSON.parse($upsellingSettings ? $upsellingSettings.textContent : "{}"); } catch (error) { data = {}; };
    const gift_items = data?.packagingOptions;
    return gift_items;
}